import { reactive } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  /** 'danger' kleurt de bevestigingsknop rood (destructieve acties). */
  variant?: 'default' | 'danger'
}

interface ConfirmState {
  open: boolean
  options: Required<ConfirmOptions>
  resolve: ((confirmed: boolean) => void) | null
}

const DEFAULTS: Required<ConfirmOptions> = {
  title: 'Bevestigen',
  message: '',
  confirmLabel: 'Bevestigen',
  cancelLabel: 'Annuleren',
  variant: 'default'
}

// Gedeeld door confirmDialog() en de ene ConfirmDialogHost aan de app-root.
export const confirmState = reactive<ConfirmState>({
  open: false,
  options: { ...DEFAULTS },
  resolve: null
})

/**
 * Promise-gebaseerde vervanger van window.confirm():
 *
 *   if (!(await confirmDialog({ message: 'Reservering annuleren?', variant: 'danger' }))) return
 */
export function confirmDialog(options: ConfirmOptions | string): Promise<boolean> {
  const normalized = typeof options === 'string' ? { message: options } : options
  // Een eventueel nog openstaande dialoog wordt als geannuleerd afgesloten.
  confirmState.resolve?.(false)
  confirmState.options = { ...DEFAULTS, ...normalized }
  confirmState.open = true
  return new Promise<boolean>(resolve => {
    confirmState.resolve = resolve
  })
}

export function settleConfirm(confirmed: boolean): void {
  confirmState.open = false
  confirmState.resolve?.(confirmed)
  confirmState.resolve = null
}
